<template>
  <div class="banner-css">
    <el-carousel height="600px" style="" class="pc" v-if="carousel.length > 1">
      <el-carousel-item v-for="(item, index) of carousel" :key="index">
        <img :src="item" alt="" style="height: 100%" />
      </el-carousel-item>
    </el-carousel>
    <div style="width:100%;" class="pc" v-if="carousel.length === 1">
      <img :src="carousel[0]" alt="" style="width:100%;vertical-align: middle;" >
    </div>
    <van-swipe class="my-swipe mobile" :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="(item, index) of Mcarousel" :key="index">
        <img :src="item" alt="" style="width: 100%;height:2rem;vertical-align: middle;" />
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
export default {
  name: "Banner",
  props: {
    carousel: {
      type: [Array,String] ,
      default: [],
    },
    Mcarousel:{
      type: [Array,String] ,
      default: [],
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/banner.vue